<div #chart class="chart-gauge" style="width: 100%"></div>
